import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import { getInfoLab } from "../../actions/labInfo/labInfoActions";

import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";

import { createTheme, ThemeProvider } from "@mui/material/styles";

import Menu from "@mui/material/Menu";

import MenuIcon from "@mui/icons-material/Menu";

import MenuItem from "@mui/material/MenuItem";

export default function Navbar({ children }) {
  const dispatch = useDispatch();

  const labInfo = useSelector((state) => state.labInfo);
  let { labInfos } = labInfo;

  useEffect(() => {
    dispatch(getInfoLab());
    // console.log(window.location.hostname);
  }, []);

  const [anchorElNav, setAnchorElNav] = React.useState(null);

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };
  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const theme = createTheme({
    typography: {
      fontFamily: ["Montserrat", "Open Sans"].join(","),
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ display: "flex" }}>
        <AppBar
          position="fixed"
          sx={{ py: -2, maxHeight: 50, bgcolor: "#1976D2" }}
        >
          <Toolbar disableGutters sx={{ px: 5, pb: 2 }}>
            <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
              <IconButton
                size="large"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
                onClick={handleOpenNavMenu}
                color="inherit"
              >
                <MenuIcon />
              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorElNav}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "left",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                open={Boolean(anchorElNav)}
                onClose={handleCloseNavMenu}
                sx={{
                  display: { xs: "block", md: "none" },
                }}
              >
                <MenuItem
                  underline="none"
                  style={{ color: "black" }}
                  href="index.html"
                  key="Accueil"
                >
                  <Typography textAlign="center">Accueil</Typography>
                </MenuItem>
                <MenuItem
                  underline="none"
                  style={{ color: "black" }}
                  href="razi.html#/patient"
                  key="Espace Patient"
                >
                  <Typography textAlign="center">Espace Patient</Typography>
                </MenuItem>
                <MenuItem
                  underline="none"
                  style={{ color: "black" }}
                  href="medecin.html"
                  key="Espace Médecin"
                >
                  <Typography textAlign="center">Espace Médecin</Typography>
                </MenuItem>
                <MenuItem
                  underline="none"
                  style={{ color: "black" }}
                  href="partenaire.html"
                  key="Espace Partenaire"
                >
                  <Typography textAlign="center">Espace Partenaire</Typography>
                </MenuItem>
                <MenuItem
                  underline="none"
                  style={{ color: "black" }}
                  href="razi.html#/loginMedecinPS"
                  key="Medecin ps"
                >
                  <Typography textAlign="center">
                    Medecin Préscripteur
                  </Typography>
                </MenuItem>

                <MenuItem
                  underline="none"
                  style={{ color: "black" }}
                  href="index.html#contact"
                  key="Contact"
                >
                  <Typography textAlign="center">Contact</Typography>
                </MenuItem>
              </Menu>
            </Box>
            <span className="icon is-medium">
              <i className="mdi mdi-24px mdi-flask-outline"></i>
            </span>
            <Typography
              variant="h6"
              noWrap
              component="a"
              href="/"
              sx={{
                mr: 2,
                display: { xs: "none", md: "flex" },
                fontFamily: "monospace",
                fontWeight: 700,
                letterSpacing: ".3rem",
                color: "inherit",
                textDecoration: "none",
                ml: 2,
              }}
            >
              {labInfos ? labInfos.TITRE_DU_LABORATOIRE : null}
            </Typography>

            <Box
              sx={{ flexGrow: 1, display: { xs: "none", md: "flex" }, py: 0 }}
            >
              <Button
                href="index.html"
                key="Accueil"
                sx={{ my: 0, color: "white", display: "block" }}
              >
                Accueil
              </Button>
              <Button
                href="razi.html#/patient"
                key="Espace Patient"
                sx={{ my: 0, color: "white", display: "block" }}
              >
                Espace Patient
              </Button>
              <Button
                href="medecin.html"
                key="Espace Médecin"
                sx={{ my: 0, color: "white", display: "block" }}
              >
                Espace Médecin
              </Button>
              <Button
                href="partenaire.html"
                key="Espace Partenaire"
                sx={{ my: 0, color: "white", display: "block" }}
              >
                Espace Partenaire
              </Button>
              <Button
                href="razi.html#/loginMedecinPS"
                key="Medecin ps"
                sx={{ my: 0, color: "white", display: "block" }}
              >
                Medecin Préscripteur
              </Button>

              <Button
                href="index.html#contact"
                key="Contact"
                sx={{ my: 0, color: "white", display: "block" }}
              >
                Contact
              </Button>
            </Box>
          </Toolbar>
        </AppBar>

        <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
          {children}
        </Box>
      </Box>
    </ThemeProvider>
  );
}
